import React from 'react';
import styles from './MessageTimestamp.module.css';

interface MessageTimestampProps {
  timestamp: string;
  isOutgoing?: boolean;
}

const MessageTimestamp: React.FC<MessageTimestampProps> = ({ timestamp, isOutgoing = false }) => {
  const parsedDate = new Date(timestamp);

  if (Number.isNaN(parsedDate.getTime())) {
    return <span className={`${styles.timestamp} ${isOutgoing ? styles['timestamp-outgoing'] : ''}`}>--:--</span>;
  }

  const value = new Intl.DateTimeFormat('pt-BR', {
    hour: '2-digit',
    minute: '2-digit',
  }).format(parsedDate);

  return <span className={`${styles.timestamp} ${isOutgoing ? styles['timestamp-outgoing'] : ''}`}>{value}</span>;
};

export default MessageTimestamp;
